module.exports = __webpack_public_path__ + "static/media/data.1020a051.tsv";